module.exports = __webpack_public_path__ + "static/media/calendar-alt-regular.3d7774c6.svg";